import React, { Component } from "react";
import "./MainContent.scss";
import "./Dashboard.scss";
import { Col, Row } from "react-bootstrap";
import GraphDailyOrderComponent from "../../common/Graphics/GraphDailyOrderComponent";
import GraphQuantityCenterComponent from "../../common/Graphics/GraphQuantityCenterComponent";
import GraphQuantityClientComponent from "../../common/Graphics/GraphQuantityClientComponent";
import { connect } from "react-redux";


class Dashboard extends Component {
	state = {
		
	};

	toggleModal = (e) => {
		this.setState({
			isVisibleMapModal: true,
		});
	};

	componentDidMount() {

	}

	componentDidUpdate(prevProps) { 
		
	}


	render() {
		
		let now = new Date();
		const initialDate = new Date().toISOString().split('T')[0];
		const finalDate = new Date(now.setDate(now.getDate() + 1)).toISOString().split('T')[0];
	
		return (
			<div className="main-content">
				<Row>
					<Col xs={12} md={6} lg={6}>
						<GraphQuantityCenterComponent>
						</GraphQuantityCenterComponent>
					</Col>
					<Col xs={12} md={6} lg={6}>
						<GraphQuantityClientComponent>
						</GraphQuantityClientComponent>
					</Col>
					<Col xs={12} md={12} lg={12}>
						<GraphDailyOrderComponent
							type="quantity"
							initialDate = { initialDate }
							finalDate = { finalDate }
						>
						</GraphDailyOrderComponent>
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	auth: state.auth
});

export default connect(mapStateToProps)(Dashboard);
